import { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { CheckCircle, Loader2, XCircle } from 'lucide-react';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL + '/api';

const PaymentSuccessPage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('loading');
  const sessionId = searchParams.get('session_id');

  useEffect(() => {
    if (!sessionId) { setStatus('error'); return; }
    const checkStatus = async () => {
      try {
        const token = localStorage.getItem('typetown_token');
        const res = await axios.get(`${API}/payments/status/${sessionId}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (res.data.payment_status === 'paid') setStatus('success');
        else if (res.data.status === 'expired') setStatus('error');
        else setTimeout(checkStatus, 2000);
      } catch { setStatus('error'); }
    };
    checkStatus();
  }, [sessionId]);

  return (
    <div className="min-h-screen bg-gradient-to-b from-cream to-warm-white flex items-center justify-center p-4">
      <div className="bg-white rounded-3xl max-w-md w-full p-8 text-center shadow-xl border-4 border-mint-green">
        {status === 'loading' && (
          <>
            <Loader2 className="w-16 h-16 text-sunny-yellow mx-auto mb-4 animate-spin" />
            <h1 className="font-display text-2xl text-text-dark mb-2">Processing Payment...</h1>
            <p className="text-text-medium">Just a moment while we confirm your subscription.</p>
          </>
        )}
        {status === 'success' && (
          <>
            <div className="w-20 h-20 bg-mint-green/20 rounded-full flex items-center justify-center mx-auto mb-4">
              <CheckCircle className="w-10 h-10 text-mint-green" />
            </div>
            <h1 className="font-display text-2xl text-text-dark mb-2">Welcome to TypeTown Premium!</h1>
            <p className="text-text-medium mb-6">Your subscription is active. All levels, zones, and buildings are now unlocked!</p>
            <button
              onClick={() => navigate('/island')}
              className="w-full py-4 bg-gradient-to-r from-mint-green to-sky-blue rounded-2xl text-white font-display font-bold text-lg hover:scale-[1.02] transition-all shadow-lg"
              data-testid="continue-playing-btn"
            >
              Continue Playing
            </button>
          </>
        )}
        {status === 'error' && (
          <>
            <div className="w-20 h-20 bg-coral-orange/20 rounded-full flex items-center justify-center mx-auto mb-4">
              <XCircle className="w-10 h-10 text-coral-orange" />
            </div>
            <h1 className="font-display text-2xl text-text-dark mb-2">Something Went Wrong</h1>
            <p className="text-text-medium mb-6">We couldn't confirm your payment. Please try again or contact support.</p>
            <button
              onClick={() => navigate('/dashboard')}
              className="w-full py-4 bg-gradient-to-r from-sunny-yellow to-coral-orange rounded-2xl text-white font-display font-bold text-lg hover:scale-[1.02] transition-all shadow-lg"
            >
              Back to Dashboard
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default PaymentSuccessPage;
